export const SERVICE_ACTIONS_ENUM = {
  DELETE: 3,
  UPDATE: 2,
  CREATE: 1
};

export const SERVICE_ITEM_TYPE_ENUM = {
  STRUCTURED: 1,
  FREE_FORM: 2
};

export const SERVICE_EDIT_ORIGIN_ENUM = {
  SINGLE_SERVICE: "single_service",
  SERVICES_CATEGORY: "services_category"
};
